import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/sonner";
import { initAnalytics } from "./lib/analytics";
import Navbar from "./components/Layout/Navbar";
import Footer from "./components/Layout/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthCallback from "./components/AuthCallback";

import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import Venues from "./pages/Venues";
import VenueDetail from "./pages/VenueDetail";
import Providers from "./pages/Providers";
import ProviderDetail from "./pages/ProviderDetail";
import EmailPreferences from "./pages/EmailPreferences";
import ProfileSettings from "./pages/ProfileSettings";
import UserProfile from "./pages/UserProfile";
import BudgetPlanner from "./pages/dashboards/BudgetPlanner";
import ForgotPassword from "./pages/ForgotPassword";
import ChangePassword from "./pages/ChangePassword";
import Legal from "./pages/Legal";
import Dashboard from "./pages/Dashboard";
import CreateEvent from "./pages/CreateEvent";
import CreateVenue from "./pages/CreateVenue";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import CookieBanner from "./components/Layout/CookieBanner";
import Faq from "./pages/Faq";
import Contact from "./pages/Contact";
import StripeConnect from "./pages/StripeConnect";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect session_id synchronously during render to handle OAuth callback
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <>
      <Navbar />
      <main className="min-h-[calc(100vh-4rem)]">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/events" element={<Events />} />
          <Route path="/events/:id" element={<EventDetail />} />
          <Route path="/venues" element={<Venues />} />
          <Route path="/venues/:id" element={<VenueDetail />} />
          <Route path="/providers" element={<Providers />} />
          <Route path="/providers/:id" element={<ProviderDetail />} />
          <Route path="/users/:id" element={<UserProfile />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/aide" element={<Faq />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/dashboard/stripe" element={<StripeConnect />} />
          <Route path="/legal/:slug" element={<Legal />} />
          <Route path="/settings/email" element={<ProtectedRoute><EmailPreferences /></ProtectedRoute>} />
          <Route path="/settings/profile" element={<ProtectedRoute><ProfileSettings /></ProtectedRoute>} />
          <Route path="/settings/password" element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
          <Route path="/dashboard/budget" element={<ProtectedRoute roles={["exhibitor"]}><BudgetPlanner /></ProtectedRoute>} />
          <Route path="/checkout/success" element={<ProtectedRoute><CheckoutSuccess /></ProtectedRoute>} />
          <Route path="/checkout/cancel" element={<CheckoutCancel />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route
            path="/dashboard/events/new"
            element={<ProtectedRoute roles={["organizer"]}><CreateEvent /></ProtectedRoute>}
          />
          <Route
            path="/dashboard/venues/new"
            element={<ProtectedRoute roles={["venue_owner"]}><CreateVenue /></ProtectedRoute>}
          />
        </Routes>
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}

function App() {
  useEffect(() => {
    initAnalytics();
  }, []);
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
